import { render, staticRenderFns } from "./TutosCollapse.vue?vue&type=template&id=61ee24e0&scoped=true&"
import script from "./TutosCollapse.vue?vue&type=script&lang=js&"
export * from "./TutosCollapse.vue?vue&type=script&lang=js&"
import style0 from "./TutosCollapse.vue?vue&type=style&index=0&id=61ee24e0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ee24e0",
  null
  
)

export default component.exports